const BUILD_ASSETS = require('./build_assets/react');
const BUILD_ASSETS_CSS = require('./build_assets/css');
const { APPLICATION_PATH, V2_ASSET_PATH } = require('./src/AppConstants');

const BASE_PATH = typeof isDev !== 'undefined' && isDev ? `${APPLICATION_PATH}/assets/` : '//jsak.mmtcdn.com/corpmice/assets/';
const BASE_IMG_PATH = typeof isDev !== 'undefined' && isDev ? `${APPLICATION_PATH}/assets/` : '//imgak.mmtcdn.com/corpmice/assets/';
const BASE_JS_PATH = typeof isDev !== 'undefined' && isDev ? `${APPLICATION_PATH}/assets/` : '//jsak.mmtcdn.com/corpmice/assets/';
const V2_BASE_IMG_PATH = typeof isDev !== 'undefined' && isDev ? `${V2_ASSET_PATH}/assets/` : `//imgak.mmtcdn.com${V2_ASSET_PATH}assets/`;
const BASE_DIST_PATH = BASE_PATH + 'dist/';
const BASE_DIST_JS_PATH = BASE_JS_PATH + 'dist/';
const BASE_MF_DIST_PATH = BASE_PATH + 'distMF/';
const BASE_MOBILE_DIST_PATH = BASE_PATH + 'distMobile/';
const BASE_MOBILE_DIST_JS_PATH = BASE_JS_PATH + 'distMobile/';

const ASSET_PATH = {
	'JS': BASE_JS_PATH + 'js/',
	'CSS': BASE_PATH + 'css/',
	'IMAGES': BASE_IMG_PATH + 'images/',
	'V2_IMAGES': V2_BASE_IMG_PATH + 'images/',
	'CORP_MICE': BUILD_ASSETS.corp_mice && BUILD_ASSETS.corp_mice.js,
	'HEADER': BUILD_ASSETS.Header && BUILD_ASSETS.Header.js,
	'HEADER_CSS': BASE_DIST_PATH + (BUILD_ASSETS_CSS.headerCss && BUILD_ASSETS_CSS.headerCss.css)
};

const PAGE_TYPE = {
	LANDING: 'LandingFlow',
	CORP_MICE: 'corp_mice',
	HEADER: 'Header',
	MOBILE: {
		SHORTLIST: 'Mice~mobile'
	}
};

module.exports = {
	ASSET_PATH,
	BASE_PATH,
	BASE_DIST_PATH,
	BASE_DIST_JS_PATH,
	PAGE_TYPE,
	BASE_MF_DIST_PATH,
	BASE_MOBILE_DIST_PATH,
	BASE_MOBILE_DIST_JS_PATH
};
